import { Box, Text } from "@nulogy/components";
import React from "react";

export default function MoreResultsMessage() {
  return (
    <Box marginTop="x4">
      <Text fontSize="small" textAlign="center">
        There may be more work orders.
      </Text>
      <Text fontSize="small" textAlign="center">
        Use search to find more.
      </Text>
    </Box>
  );
}
